import { Locale } from './types'

export default {
    FLAG2: {
        idk: 'ناشناخته',
        yes: 'بله',
        no: 'خیر',
    },
    DISH_FLAGS: { is_hidden: 'مخفی است' },
    DISH_DAILY: {
        is_daily: 'روزانه است',
        in_saturday: 'در شنبه',
        in_sunday: 'در یک شنبه',
        in_monday: 'در دو شنبه',
        in_tuesday: 'در سه شنبه',
        in_wednesday: 'در چهار شنبه',
        in_thursday: 'در پنج شنبه',
        in_friday: 'در جمعه',
    },
    DISH_KIND: {
        best_dishes: 'بهترین ها',
        unknown: 'نامشحص',
        food: 'غذا',
        pizza: 'پیتزا',
        burger: 'برگر',
        dessert: 'دسر',
        pasta: 'پاستا',
        icecream: 'بستنی',
        seafood: 'دریایی',
        soup: 'سوپ',
        kabab: 'کباب',
        polo: 'پلو',
        chicken: 'مرغ',
        steak: 'استیک',
        sandwich: 'ساندویچ',
        sandwich_hotdog: 'هات داگ',
        salad: 'سالاد',
        fried: 'سوخاری',
        drink: 'نوشیدنی',
        tea: 'چای',
        tea_ice: 'چای سرد',
        coffee: 'قهوه گرم',
        coffee_ice: 'قهوه سرد',
        soda: 'نوشابه',
        bread: 'نان',
        cake: 'کیک',
        cookie: 'کوکی',
        croissant: 'کروسان',
        sharbat: 'شربت',
        waffle: 'وافل',
        juice: 'موکتل',
        chocolate: 'شکلات',
        milkshake: 'شیک',
        smoothie: 'اسموتی',
        ash: 'آش',
        sushi: 'سوشی',
        meat: 'گوشت',
        noodle: 'نودل',
        sides: 'کنار غذا',
        tea_herbal: 'دمنوش',
        friedegg: 'نیمرو',
        omelette: 'املت',
        qelyan: 'قلیان',
        appetizer: 'پیش غذا',
        other: 'دیگر',
        cigar: 'سیگار',
        milk: 'شیر',
        service: 'سرویس',
        ___fish: 'ماهی',
    },
    BOOL: {
        false: 'خیر',
        true: 'بله',
    },
    EATERY_TAGS: {
        has_self_service: 'سلف سرویس',
        has_vegetarian_food: 'غذای گیاهی',
        has_vegan_food: 'غذای وگان',
        has_dine_in: 'ناهار خوری',
        has_wifi: 'وای‌‌فای رایگان',
        has_lunch: 'ناهار',
        has_tv: 'تلویزیون',
        has_solo_dining: 'ناهار خوری انفرادی',
        has_reservations: 'قابل رزرو',
        has_toilet: 'سرویس بهداشتی',
        has_delivery: 'تحویل غذا',
        has_live_music: 'موسیقی زنده',
        has_dinner: 'شام',
        has_drive_through: 'سفارش داخل ماشین',
        has_indoor_seating: 'صندلی داخل سالن',
        has_breakfast: 'صبحانه',
        has_halal_food: 'غذای حلال',
        has_private_dining: 'ناهار خوری خصوصی',
        has_parking: 'پارکینگ',
        has_takeaway: 'بیرون بر',
        has_outdoor_seating: 'صندلی فضای باز',
        is_tourist_friendly: 'جاذبه توریستی',
        is_wheelchair_accessible: 'دسترسی با ویلچر',
        is_suitable_for_pets: 'حیوانات خانگی',
        is_suitable_for_children: 'کودکان',
        is_suitable_for_large_groups: 'گروه‌های بزرگ',
        can_smoke_indoor: 'سیگار داخل آزاد',
        allows_long_stays: 'امکان نشستن طولانی',
        has_dj: 'دیجی ( Dj )',
        has_good_view: 'ویو خوب',
        has_qelyan: 'قلیان',
        is_photogenic: 'لوکیشن عکاسی',
        is_suitable_for_reading: 'کتاب خوانی',
        is_suitable_for_social_working: 'فضای کار اشتراکی',
    },
    PREFERENCES_EATERY_TAGS: {
        has_wifi: 'وای‌فای رایگان',
        has_tv: 'تلویزیون',
        has_reservations: 'قابلیت رزرو',
        has_toilet: 'سرویس بهداشتی',
        has_live_music: 'موسیقی زنده',
        has_parking: 'پارکینگ راحت',
        has_indoor_seating: 'صندلی داخل سالن',
        has_outdoor_seating: 'صندلی در فضای باز',
        is_suitable_for_pets: 'مناسب حیوانات خانگی',
        is_suitable_for_children: 'برای کودکان مناسب باشه',
        is_suitable_for_large_groups: 'برای گروه‌های بزرگ مناسب باشه',
        can_smoke_indoor: 'امکان سیگار کشیدن داخل سالن',
        allows_long_stays: 'امکان نشستن طولانی',
        has_dj: 'دیجی ( Dj )',
        has_good_view: 'ویو خوب',
        has_qelyan: 'قلیان داشته باشه',
        is_photogenic: 'لوکیشن مناسب عکاسی',
        is_suitable_for_reading: 'برای کتاب‌خوانی مناسب باشه',
        is_suitable_for_social_working: 'فضای کار اشتراکی',
        //
        has_delivery: 'ارسال غذا داشته باشه؟',
        has_lunch: 'ناهار سرو کنه؟',
        has_drive_through: 'امکان سفارش داخل ماشین',
        has_self_service: 'سلف‌سرویس باشه؟',
        has_solo_dining: 'ناهار خوری انفرادی',
        has_vegetarian_food: 'غذای گیاهی',
        has_vegan_food: 'غذای وگان',
        has_dine_in: 'ناهار خوری',
        has_dinner: 'شام',
        is_wheelchair_accessible: 'دسترسی با ویلچر',
        is_tourist_friendly: 'جاذبه توریستی',
        has_breakfast: 'صبحانه',
        has_halal_food: 'غذای حلال',
        has_private_dining: 'ناهار خوری خصوصی',
        has_takeaway: 'بیرون‌بر',
    },
    EVENTS: {
        christmas: 'کریسمس',
        norooz: 'نوروز',
        scarlet_wednesday: 'چهارشنبه سوری',
        valentine: 'ولنتاین',
        yalda: 'یلدا',
        halloween: 'هالووین',
        none: 'هیج!',
        fifa_world_cup: 'جام جهانی',
    },
    SORT_ORDER: {
        // desc: 'نزولی',
        // asc: 'صعودی',
        desc: 'پایین به بالا',
        asc: 'بالا به پایین',
        // desc: 'بالا به پایین',
        // asc: 'پایین به بالا',
    },
    FILTER_NUMBER_OPT: {
        gt: 'بیشتر از',
        lt: 'کمتر از',
        eq: 'برابر با',
        ne: 'مخالف با',
        in: 'درون',
        not_in: 'نبودن درون',
    },
    EATERY_SORT: {
        is_brand: 'برند بودن',
        is_unique: 'خاص بودن',
        geo_point: 'نزدیک ترین',
        review_count: 'بیشترین تعداد نظر',
        star_sum: 'امتیاز',
        stars: 'بیشترین ستاره',
        quality_score: 'امتیاز کیفیت',
        score: 'بهترین کیفیت',
        dish_count: 'تعداد آیتم منو',
        price_range_avg: 'میانگین قیمت',
        price_range_max: 'گرون ترین',
        price_range_min: 'ارزون ترین',
        random_id: 'رندوم',
        is_famous: 'معروف بودن',
        is_tender: 'پیشنهاد گوجه',
        is_tourist_attraction: 'محل توریستی',
        last_activity: 'آخرین آنلاین',
        verified_until: 'تضمین دار',
    },
    DAYS_OF_WEEK: {
        saturday: 'شنبه',
        sunday: 'یک شنبه',
        monday: 'دوشنبه',
        tuesday: 'سه شنبه',
        wednesday: 'چهارشنبه',
        thursday: 'پنج شنبه',
        friday: 'جمعه',
    },
    EATERY_FLAGS: {
        is_perma_close: 'کامل بسته شده',
        is_brand: 'برند ',
        is_unique: 'جالب ',
        is_famous: 'معروف',
        has_content_in_1_month: 'محتوا در یک ماه گذشته',
        has_content_in_3_months: 'محتوا در سه ماه گذشته',
        has_content_in_1_year: 'محتوا در یک سال گذشته',
        holds_birthday_parties: 'گرفتن جشن تولد',
        is_low_quality: 'کم کیفیت',
        is_tender: 'پیشنهاد گوجه',
        is_tourist_attraction: 'جاذبه توریستی',
        is_close: 'بسته',
        is_for_guest: 'برای مهمان',
        is_hidden: 'مخفی',
        is_24_7: 'شبانه روزی',
        is_address_custom: 'آدرس دستی',
        is_address_google: 'آدرس گوگل',
        is_address_parsimap: 'آدرس نشان',
        has_employee: 'کارمند دارد',
        trailer_m3u8_rendered: 'تریلیر چند کیفیتی شده',
        trailer_preview_rendered: 'تریلیر ساخته شده',
    },
    EATERY_DOMAIN: {
        none: 'معمولی',

        // Cafe
        cafe: 'کافه',
        bakery: 'بیکری',
        teahouse: 'چایخانه',

        // Restaurant
        restaurant: 'رستوران',
        seafood: 'دریایی',
        dizi: 'دیزی',
        ash: 'آش',
        kababi: 'کبابی',
        kalle_pache: 'کله پاچه',
        liver: 'جگر',

        // Fast food
        fast_food: 'فست فود',
        hot_dog: 'هات داگ',
        sandwich: 'ساندویچ',
        falafel: 'فلافل',
        fried: 'سوخاری',

        // Dessert
        dessert: 'آبمیوه بستنی',
        ice_cream: 'بستنی',
        juicery: 'آب‌میوه',
        gelato: 'جلاتو',
    },
    EATERY_GROUP: {
        unknown: 'نامعلوم',
        cafe: 'کافه',
        dessert: 'آبمیوه بستنی',
        restaurant: 'رستوران',
        fast_food: 'فست فود',
    },
    PREFERENCE_EATERY_GROUP: {
        unknown: 'نامعلوم',
        cafe: 'کافه و شیرینی',
        fast_food: 'فست فود‌ ها',
        restaurant: 'رستوران‌ ها',
        dessert: 'دسر‌ ها',
    },
    EATERY_AUDIENCE_DROPDOWN: {
        none: 'مشتری عادی',
        couples: 'کاپلی',
        friends: 'پاتوق',
        family: 'خانوادگی',
        business: 'بیزینسی',
    },
    EATERY_DECOR_DROPDOWN: {
        none: 'دکور عادی',
        luxury: 'شیک',
        musical: 'موزیکال',
        game: 'گیم',
        traditional: 'سنتی',
        nature: 'طبیعت',
        street: 'خیابونی',
        fantasy: 'فانتزی',
        bookish: 'کتابی',
        cultural: 'فرهنگی',
        minimal: 'مینیمال',
        modern: 'مدرن',
    },
    EATERY_DECOR: {
        none: 'دکور عادی',
        luxury: 'شیک',
        musical: 'موزیکال',
        game: 'گیم',
        traditional: 'سنتی',
        nature: 'طبیعت',
        street: 'خیابونی',
        fantasy: 'فانتزی',
        bookish: 'کتابی',
        cultural: 'فرهنگی',
        minimal: 'مینیمال',
        modern: 'مدرن',
    },
    EATERY_AUDIENCE: {
        none: 'مشتری عادی',
        couples: 'کاپلی',
        friends: 'پاتوق',
        family: 'خانوادگی',
        business: 'بیزینسی',
    },
    // home start
    HOME_EATERY_DOMAIN: {
        none: 'یه جای خودمونی می‌خوای؟',

        // Cafe
        cafe: 'هوس یه کافه کردی؟',
        bakery: 'یه بیکری خوب می‌خوای؟',
        teahouse: 'یه چایخونه نریم؟',

        // Restaurant
        restaurant: 'دلت یه غذای درست‌وحسابی می‌خواد؟',
        seafood: 'هوس غذای دریایی کردی؟',
        dizi: 'یه دیزی می‌چسبه؟',
        ash: 'یه کاسه آش می‌چسبه؟',
        kababi: 'هوس کباب کردی؟',
        kalle_pache: 'یه کله‌پاچه نزنیم؟',
        liver: 'یه جگرکی خفن نزنیم؟',

        // Fast food
        fast_food: 'یه چیز سریع و خوشمزه می‌خوای؟',
        hot_dog: 'هوس هات‌داگ کردی؟',
        sandwich: 'یه ساندویچ حسابی می‌چسبه؟',
        falafel: 'فلافل خفن کجا بخوریم؟',
        fried: 'یه سوخاری خفن می‌خوای؟',

        // Dessert
        dessert: 'یه چیز خنک و شیرین می‌چسبه؟',
        ice_cream: 'یه بستنی خفن نزنیم؟',
        juicery: 'یه آبمیوه خنک می‌خوای؟',
        gelato: 'هوس جلاتو کردی؟',
    },
    HOME_EATERY_GROUP: {
        unknown: 'هنوز نمی‌دونی چی می‌خوای؟',
        cafe: 'هوس یه کافه کردی؟',
        dessert: 'یه چیز خنک و شیرین می‌چسبه؟',
        restaurant: 'غذای درست‌وحسابی کجا بخوریم؟',
        fast_food: 'یه چیز سریع و خوشمزه می‌خوای؟',
    },
    HOME_EATERY_DECOR: {
        none: 'یه جای ساده و خودمونی؟',
        luxury: 'یه جای شیک و باکلاس؟',
        musical: 'یه جای موزیکال می‌خوای؟',
        game: 'یه جا برای بازی و خوش‌گذرونی؟',
        traditional: 'یه جای اصیل ایرانی می‌خوای؟',
        nature: 'یه جای سبز و دنج می‌خوای؟',
        street: 'بهترین جاهای خیابونی',
        fantasy: 'دنبال یه جای عجیب می‌گردی؟',
        bookish: 'یه جای آروم با دکور کتابی؟',
        cultural: 'سفر کوچیک به یه فرهنگ دیگه؟',
        minimal: 'ساده و خوش‌سلیقه می‌خوای؟',
        modern: 'یه جای مدرن و امروزی؟',
    },
    HOME_EATERY_AUDIENCE: {
        none: 'یه جای همه‌پسند می‌خوای؟',
        couples: 'یه جای دونفره می‌خوای؟',
        friends: 'پاتوق بعدیتون بگم کجا باشه؟',
        family: 'با خانواده کجا برم؟',
        business: 'یه جای مناسب قرار کاری؟',
    },
    // home end
    REVIEW_STATE: {
        admin_censored: 'نظر توسط ادمین رد شده!',
        admin_verified: 'نظر توسط ادمین تایید شده',
        golem_censored: 'نظر توسط سیستم رد شده!',
        golem_verified: 'نظر توسط سیستم تایید شده',
        default: 'منتظر تصمیم...',
        staff_verified: 'نظر توسط غذاخوری تایید شده',
        staff_censored: 'نظر توسط غذاخوری رد شده!',
        user_deleted: 'نظر توسط کاربر حذف شده!',
    },
    GENDERS: {
        female: 'خانم',
        male: 'آقای',
        unknown: 'نامعلوم',
    },
    CRIMES_LABELS: {
        advertising: 'تبلیغات غیر مجاز',
        illegal: 'خلاف قوانین گوجه',
        nsfw: 'محتوا غیر اخلاقی',
        other: 'دیگر',
        swearing: 'فحاشی',
        trolling: 'بد اخلاقی',
        unknown: 'توسط سیستم',
        spam: 'اسپم',
    },
    TRANSACTION_KIND: {
        eatery_rob_transfer: 'انتقال رُب به غذاخوری',
        rob_reward: 'پاداش رُب',
        rob_purchase: 'خرید رُب',
        rob_gift: 'هدیه رُب',
        zarinpal: 'زرین پال',
        zibal: 'زیبال',
        unknown: 'ارور سیستم',
        item_purchase: 'خرید آیتم',
    },
    ITEM_KINDS: {
        discount: 'کد تخفیف',
        unknown: 'نامعلوم',
    },

    TRANSACTION_STATES: {
        failure: 'رد شده!',
        pending: 'حالت انتظار',
        success: 'موفق!',
    },
    TRANSACTION_CURRENCIES: {
        iran_rial: 'ریال',
        unknown: 'نامعلوم',
    },
    WALLET_CURRENCIES: {
        irr: 'ریال',
        rob: 'رُب',
    },
    FEEDBACK_KINDS: {
        bug: 'باگ',
        chatting: 'در حال چت',
        criticism: 'انتقاد',
        resolved: 'حل شده!',
        suggestion: 'پیشنهاد',
        unknown: 'ناشناس',
    },
    REWARD_REASON: {
        joined_invite: 'استفاده از کد دعوت',
        friend_invite: 'دعوت از دوستات',
        suggest_edit: 'پیشنهاد اطلاعات غذاخوریت',
        suggest_add: 'پیشنهاد اضافه غذاخوریت',
        suggest_removal: 'پیشنهاد حذف غذاخوریت',
        unknown: 'نامعلوم',
    },
    FEEDBACK_STATUS: {
        chatting: 'در حال چت',
        pending: 'در حال بررسی',
        resolved: 'حل شده!',
        unknown: 'ناشناس',
    },
    SUGGEST_KINDS: {
        add: 'پیشنهاد اضافه غذاخوری',
        edit: 'تغییر اطلاعات غذاخوری',
        removal: 'پیشنهاد حذف غذاخوری',
        unknown: 'نامعلوم',
    },
    TICKET_RESPONSE_STATUS: {
        none: 'بدون وضعیت',
        pending: 'در حال بررسی',
        rejected: 'رد شده',
        resolved: 'تایید شده',
    },
    SEED_ERROR: {
        preference_too_big: 'اولویت بیشتر از 100',
        spice_build: 'ساخت اسپایس به مشکل برخورد',
        incompatible_domain: 'گروه غذایی اشتباه',
        bad_compact_gene: 'پیدا نشد',
        invalid_code: 'کد تخفیف اشتباهه',
        not_appliable: 'مد تخفیف قابل تایید نیست',
        not_started: 'شروع نشده',
        no_discount_available: 'کد تخفیف نداریم!',
        not_invitable: 'کد استفاده شده یا محلتش تمام شده',
        already_reported: 'این رو قبلا گزارش دادید.',
        wheat: 'دریافت اطلاعات با مشکل مواجه شد',
        storage_limit: 'رب تمام شده!',
        rob_not_available: 'رب موجود نیست!',
        bad_feedback_status: 'فیدبک استاتوس بد!',
        bad_video_size: 'سایز ویدیو بیش از حد زیاد یا کم است',
        invalid_audio: 'فایل صدا مشکل داره',
        invalid_video: 'فایل ویدیو مشکل داره',
        video_too_long: 'ویدیو بیشتر از 30 ثانیه است!',
        video_too_short: 'ویدیو کمتر 10 ثانیه است!',
        video_conversion: 'فایل ویدیو mp4 نیست!',
        invalid_task_id: 'تسک اشتباه است!',
        invalid_ipv4: 'ipv4 اشتباهه',
        insufficient_money: 'مقدار کیف پول کافی نیست!',
        insufficient_rob: 'مقدار رُب کافی نیست!',
        unknown_impression: 'استیکر در سیستم نیست',
        not_member: 'جزوی از کارکنان نیستید!',
        not_associated: 'جزوی از کارکنان نیستید!',
        empty_message: 'پیام خالی است!',
        member_list_full: 'حداکثر کارکنان پر شده!',
        saved_full: 'حداکثر ذخیره پر شده!',
        request_pending: 'درخواست حالت انتظار داری!',
        associated_topics_full: '',
        topic_record_media_mismatch: 'فرمت فایل درست نیست!',
        permission_denied: 'دسترسی ندارید!',
        already_exists: 'از قبل وجود دارد!',
        expired: 'تاریخ انقضا تمام شده!',
        limit_reached: 'تعداد به حداکثر رسیده!',
        subscription_limit_reached: 'محدودیت شما برای این پلن پر شده!',
        payment_processor_failed: 'خطا در تراکنش!',
        associated_eateries_full: 'تعداد کارکنان به حداکثر رسیده',
        bad_username: 'نام کاربری بد',
        username_in_use: 'این نام کاربری در دست کس دیگریست',
        not_for_guest: 'برای مهمان نیست',
        duplicate_khabar: 'خبر تکراری',
        detail_too_long: 'توضیحات طولانی',
        not_draft: 'پیش نویس نمی باشد',
        not_pending: 'درانتظار نمی باشد',
        too_many_dish: 'حداکثر اضافه کردن غذا رسید',
        image_download_failed: 'دانلود عکس از گوگل به مشکل برخورد',
        cannot_change_kind: 'تغییر نوع درحین اپدیت امکان پذیر نمی باشد',
        bad_kind_unknown: 'نوع نامعلوم',
        invalid_state_unknown_kind: 'نوع نامعلوم',
        spark_target_unknown: 'نوع نامعلوم',
        zstd_compress_failed: 'نوع نامعلوم',
        clone_in_progress: 'در حال کلون‌سازی',
        unknown: 'خطایی ناشناخته رخ داد',
        bad_request: 'درخواست نامعتبر',
        forbidden: 'درخواست غیرمجاز',
        bad_auth: 'احراز هویت نامعتبر',
        not_found: 'موردی یافت نشد',
        server_error: 'خطای سرور',
        database_error: 'خطای پایگاه داده',
        change_while_reordering: 'تغییر هنگام مرتب‌سازی',
        index_out_of_bounds: 'آیتم از بازه خارج است',
        invalid_image: 'تصویر نامعتبر',
        encode_webp_error: 'تبدیل تصویر به فرمت webp ناموفق بود',
        end_point_under_maintenance: 'این بخش در حال آپدیت است',
        clone_from_self: 'امکان کلون‌سازی از خود وجود ندارد',
        password_mismatch: 'رمز عبور اشتباه است!',
        rate_limited: 'بعدا دوباره تلاش کنید',
        bad_phone: 'شماره تلفن نامعتبر',
        buckle_gene_is_none: 'یافت نشد',
        golem_banned: 'بن توسط سرور',
        golem_permission: '',
        user_banned: 'کاربر بن شده',
    },
} satisfies Locale
